import PropTypes from 'prop-types'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls, useRelations } from '@hooks/usePublication'

const PublicationListItem = (props) => {
  const {
    publication,
    publication: {
      id,
      title,
    },
  } = props

  const { editPublicationRelationsUrl } = generateUrls(publication)

  const { provider } = useRelations(publication)

  return (
    <DashboardModuleListItem
      href={editPublicationRelationsUrl}
      secondaryText={provider?.title}
      title={title}
    >
      <DashboardModuleListItem.TertiaryText>
        # {id}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

PublicationListItem.propTypes = {
  publication: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
}

export default PublicationListItem
